/** Email di avviso e di prova, nella lingua dell'istanza. */
export const email = {
  "email.stack": (p: { stack: string }) => `Stack: ${p.stack}`,
  "email.stackSconosciuto": (p: { id: number }) => `stack ${p.id}`,
  "email.servizio": (p: { servizio: string }) => `Servizio: ${p.servizio}`,
  "email.regola": (p: { regola: string }) => `Regola: ${p.regola}`,
  "email.valore": (p: { valore: string }) => `Valore raggiunto: ${p.valore} %`,
  "email.da": (p: { quando: string }) => `Da: ${p.quando}`,
  "email.fino": (p: { quando: string }) => `Fino a: ${p.quando}`,
  "email.apri": (p: { link: string }) => `Apri in Portman: ${p.link}`,
  "email.oggetto": (p: { rientro: boolean; stack: string; servizio: string; regola: string }) =>
    `[Portman] ${p.rientro ? "rientrato — " : ""}${p.stack} · ${p.servizio}: ${p.regola}`,
  "email.cpu": "CPU",
  "email.memoria": "memoria",
  "email.sopraSoglia": (p: { nome: string; soglia: number; minuti: number }) =>
    `${p.nome} sopra il ${p.soglia}% per ${p.minuti} minuti`,
  "email.senzaMisure": "Nessuna misura da 5 minuti: il container non è più in esecuzione.",
  "email.oom": "ucciso per memoria esaurita (OOM)",
  "email.fermato": (p: { codice: number | null }) => `fermato inaspettatamente (codice di uscita ${p.codice})`,
  "email.silenzioArresti": "Altri arresti di questo servizio nei prossimi 30 minuti non saranno inviati per email.",
  "email.silenzioOom": "Altri OOM di questo servizio nei prossimi 30 minuti non saranno inviati per email.",
  "email.ripartito": "Il container è ripartito.",
  "email.rimastoFermo": "Il container è rimasto fermo.",
  "email.provaOggetto": "[Portman] email di prova",
  "email.provaTesto": "Questa è un'email di prova di Portman: la configurazione degli avvisi funziona.",
};
